import KKPromo from "@/svg/KinoklubbKnappEksternekinosider";
import classNames from "classnames";
import Link from 'next/link';
import styles from "./KinoklubbTicket.module.css";


//#region [Props]
export type KinoklubbTicketProps = {
    className?: string;
};
//#endregion

//#region [Component]
export default function KinoklubbTicket({ className }: KinoklubbTicketProps) {
    return <Link href="https://www.kinoklubb.no/" target="_blank" className={classNames(styles.KinoklubbTicket, className)}>
        <div className={styles.Promo}>
            <KKPromo role="img" />
        </div>
    </Link>;
}
//#endregion
